import { render, staticRenderFns } from "./inputRegion.vue?vue&type=template&id=37e57569"
import script from "./inputRegion.vue?vue&type=script&lang=js"
export * from "./inputRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dropdown: require('/var/www/html/jayuvillage/components/dropdown.vue').default})
